import { redirect, RouteObject } from 'react-router-dom'
import axios from 'axios'
import { base_url } from 'env'
import SubscriptionsPage from 'pages/Subscriptions/Subscriptions'
import SubscriptionCreatePage from 'pages/Subscriptions/SubscriptionCreate'
import SubscriptionPreviewPage from 'pages/Subscriptions/SubscriptionPreview'
import SubscriptionEditPage from 'pages/Subscriptions/SubscriptionEdit'

export const SubscriptionRoutes: RouteObject[] = [
  {
    path: '/subscriptions',
    loader: async () => {
      try {
        const response = await axios.get(base_url + '/subscription/')
        return response.data
      } catch (error) {
        console.error(error)
        return []
      }
    },
    element: <SubscriptionsPage />,
  },
  {
    path: '/subscription',
    element: <SubscriptionCreatePage />,
  },
  {
    path: '/subscription/:id',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(base_url + `/subscription/${params.id}`)
        return response.data
      } catch (error) {
        console.error(error)
        return redirect('/subscriptions')
      }
    },
    element: <SubscriptionPreviewPage />,
  },
  {
    path: '/subscription/:id/edit',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(base_url + `/subscription/${params.id}`)
        return response.data
      } catch (error) {
        console.error(error)
        return redirect('/subscriptions')
      }
    },
    element: <SubscriptionEditPage />,
  },
]
